import { useState } from 'react';

export type ISort = {
    [key: string]: 1 | -1;
} | undefined;

export const useTableSort = () => {
    const [ sort, setSort ] = useState<ISort>(undefined);

    const getSort = (id: string) => {
        let sortObj: ISort;
        if (!sort) {
            sortObj = {
                [id]: 1
            }
        } else {
            if (id in sort) {
                if (sort[id] === 1) {
                    sortObj = {
                        [id]: -1
                    }
                } else {
                    sortObj = undefined;
                }
            } else {
                sortObj = {
                    [id]: 1
                }
            }
        }
        return sortObj;
    }

    return {
        sort,
        getSort,
        setSort
    }
}